export class QaCompleteSendConfigUnavailableError extends Error {
  constructor() {
    super("QA Complete could not resolve the Send QA configuration.");
    this.name = "QaCompleteSendConfigUnavailableError";
  }
}

export function normalizeQaCompleteSendConfig(value) {
  let config = value;

  if (typeof config === "string") {
    try {
      config = JSON.parse(config);
    } catch (error) {
      return null;
    }
  }

  if (
    !config ||
    typeof config !== "object" ||
    Array.isArray(config) ||
    Object.keys(config).length === 0
  ) {
    return null;
  }

  return config;
}

export async function resolveQaCompleteSendConfig(currentConfig, loadConfig) {
  const availableConfig = normalizeQaCompleteSendConfig(currentConfig);
  if (availableConfig) {
    return {
      config: availableConfig,
      refreshed: false,
      shouldSend: availableConfig.SendQAwithQAComplete === true,
    };
  }

  const refreshedConfig = normalizeQaCompleteSendConfig(await loadConfig());
  if (!refreshedConfig) {
    throw new QaCompleteSendConfigUnavailableError();
  }

  return {
    config: refreshedConfig,
    refreshed: true,
    shouldSend: refreshedConfig.SendQAwithQAComplete === true,
  };
}

export function shouldPromptForQaCompleteBatch({
  batchMarkComplete,
  batchProcessingStatus,
  currentDocumentId,
  documents,
  shouldSend,
}) {
  if (
    batchMarkComplete !== true ||
    batchProcessingStatus !== "Complete" ||
    shouldSend !== true
  ) {
    return false;
  }

  return (Array.isArray(documents) ? documents : []).some((document) => {
    const processingStatus = `${document?.processingStatus || ""}`.trim().toLowerCase();

    return (
      document?.batchProcessingStatus === "Complete" &&
      document?.document_id !== currentDocumentId &&
      !["uploaded", "in progress", "in-progress", "extracted"].includes(processingStatus) &&
      processingStatus !== "qa complete"
    );
  });
}
